// import React, { useContext, useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   Dialog,
//   Snackbar,
//   DialogContent,
//   LinearProgress,
//   Alert,
// } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import { AutoTaskAuthContext } from "../Context/AutoTaskContext";
// import axios from "axios";

// /* ------------------ Helper Functions ------------------ */
// const getCurrentWeek = () => {
//   const today = new Date();
//   const firstJan = new Date(today.getFullYear(), 0, 1);
//   const days = Math.floor((today - firstJan) / (24 * 60 * 60 * 1000));
//   return Math.ceil((days + firstJan.getDay() + 1) / 7);
// };

// const getWeekStartDate = (week, year = new Date().getFullYear()) => {
//   const firstDayOfYear = new Date(year, 0, 1);
//   return new Date(
//     firstDayOfYear.setDate(firstDayOfYear.getDate() + (week - 1) * 7),
//   );
// };

// const getWeekRange = (week, year = new Date().getFullYear()) => {
//   const start = getWeekStartDate(week, year);
//   const end = new Date(start);
//   end.setDate(start.getDate() + 6);

//   const format = (d) =>
//     d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

//   return `${format(start)} – ${format(end)}`;
// };

// //------------------- Get gradient ------------------------
// const getGradient = (value) => {
//   if (value > 80) {
//     return "linear-gradient(90deg, #0cb2dbff, #006381ff)"; // blue
//   }
//   if (value >= 60) {
//     return "linear-gradient(90deg, #facc15, #f97316)"; // yellow → orange
//   }
//   return "linear-gradient(90deg, #ef4444, #f97316)"; // red → orange
// };

// /* ------------------ WeeklyReport ------------------ */
// const WeeklyReport = () => {
//   const { userInfo } = useContext(AutoTaskAuthContext) || {};

//   const [week, setWeek] = useState(getCurrentWeek());
//   const [targets, setTargets] = useState([]);
//   const [isAllFilled, isSetAllFilled] = useState(false);

//   const [snackBarConfig, setSnackBarConfig] = useState({
//     open: false,
//     message: "",
//     severity: "",
//   });

//   const currentWeek = getCurrentWeek();
//   const isCurrentWeek = week === currentWeek;

//   const handleClose = (e, reason) => {
//     if (reason === "clickaway") return;
//     setSnackBarConfig((prevState) => ({ ...prevState, open: false }));
//   };

//   useEffect(() => {
//     const getWeeklyTasks = async () => {
//       const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/weeklyTasks/${userInfo.id}/${week}`;

//       try {
//         const response = await axios.get(url);

//         if (response?.data?.success) {
//           const tasks = response?.data?.data || [];

//           // Check if any task is incomplete
//           const hasIncompleteTask = tasks.some((task) => task?.completed == 0);

//           hasIncompleteTask ? isSetAllFilled(false) : isSetAllFilled(true);

//           // Store initial completed value
//           const tasksWithInitial = tasks.map((task) => ({
//             ...task,
//             initial_completed: task.completed,
//           }));

//           setTargets(tasksWithInitial);
//         } else {
//           setSnackBarConfig({
//             open: true,
//             message: response?.data?.message || "Failed to fetch tasks",
//             severity: "error",
//           });
//         }
//       } catch (error) {
//         setSnackBarConfig({
//           open: true,
//           message: "Error fetching weekly tasks",
//           severity: "error",
//         });
//       }
//     };

//     if (userInfo?.id) {
//       getWeeklyTasks();
//     }
//   }, [week, userInfo?.id]);

//   const handleTargetChange = (index, field, value) => {
//     setTargets((prev) =>
//       prev.map((target, i) =>
//         i === index ? { ...target, [field]: value } : target,
//       ),
//     );
//   };

//   // Month derived from selected week
//   const weekStartDate = getWeekStartDate(week);
//   const currentMonth = weekStartDate.toLocaleString("default", {
//     month: "long",
//     year: "numeric",
//   });

//   // Calculate completion percentage
//   const totalTarget = targets.reduce(
//     (sum, t) => sum + Number(t.target || 0),
//     0,
//   );
//   const totalCompleted = targets.reduce(
//     (sum, t) => sum + Number(t.completed || 0),
//     0,
//   );
//   const completionPercentage =
//     totalTarget > 0 ? Math.round((totalCompleted / totalTarget) * 100) : 0;

//   // Handle Save Sprint
//   const handleSaveSprint = async () => {
//     const payload = targets.map((target) => ({
//       user_task_id: target.task_id, // IMPORTANT: real task id from backend
//       week_no: week,
//       completed: Number(target.completed || 0),
//       remarks: target.remarks || "",
//       report_date: new Date().toISOString().split("T")[0],
//     }));

//     try {
//       const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/addWeeklyLogs`;
//       const response = await axios.post(url, payload);

//       if (response?.data?.success) {
//         setSnackBarConfig({
//           open: true,
//           message: "Weekly progress saved successfully",
//           severity: "success",
//         });
//       } else {
//         setSnackBarConfig({
//           open: true,
//           message: response?.data?.statusMessage || "Something went wrong",
//           severity: "error",
//         });
//       }
//     } catch (error) {
//       setSnackBarConfig({
//         open: true,
//         message: "Failed to save weekly progress",
//         severity: "error",
//       });
//     }
//   };

//   return (
//     <Box px={4}>
//       {/* -------- Week Selector Bar -------- */}
//       <Box
//         sx={{
//           background: "#fff",
//           borderRadius: "12px",
//           boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
//           px: 3,
//           py: 2,
//           my: 2,
//           display: "flex",
//           alignItems: "center",
//           gap: 3,
//         }}
//       >
//         <Typography fontSize={14} color="text.secondary">
//           Month
//         </Typography>

//         <Box
//           sx={{
//             px: 2,
//             py: 0.7,
//             border: "1px solid #e0e0e0",
//             borderRadius: "8px",
//             fontSize: 14,
//             color: "#777",
//           }}
//         >
//           {currentMonth}
//         </Box>

//         <Box sx={{ height: 56, borderRight: "2px solid #dadada75" }} />

//         <Typography fontSize={14} color="text.secondary">
//           Week
//         </Typography>

//         <Select
//           size="small"
//           value={week}
//           onChange={(e) => setWeek(e.target.value)}
//           sx={{ minWidth: 90, borderRadius: "8px" }}
//         >
//           {Array.from({ length: 52 }, (_, i) => (
//             <MenuItem key={i + 1} value={i + 1}>
//               {i + 1}
//             </MenuItem>
//           ))}
//         </Select>

//         <Typography sx={{ color: "#a3a3a3ff" }} ml="auto" fontWeight={400}>
//           Week {week} ({getWeekRange(week)})
//         </Typography>
//       </Box>

//       {/* Progress Bar */}
//       <Box sx={{ width: "100%", mb: 3 }}>
//         <LinearProgress
//           variant="determinate"
//           value={completionPercentage}
//           sx={{
//             boxShadow: 4,
//             height: 20,
//             borderRadius: 5,
//             backgroundColor: "#e5e7eb",
//             "& .MuiLinearProgress-bar": {
//               borderRadius: 5,
//               background: getGradient(completionPercentage),
//             },
//           }}
//         />

//         <Typography
//           fontSize={12}
//           mt={0.5}
//           textAlign="right"
//           fontWeight={500}
//           color="text.secondary"
//         >
//           {completionPercentage}% Completed
//         </Typography>
//       </Box>

//       {/* Weekly Targets Section */}
//       <Box>
//         <Typography sx={{ mb: 2, fontWeight: "bold", fontSize: 18 }}>
//           Weekly Targets
//         </Typography>

//         {targets.length === 0 && (
//           <Typography variant="body2" color="text.secondary">
//             No targets have been set for this week yet.
//           </Typography>
//         )}

//         {/* Grid Layout for Targets */}
//         <Box
//           sx={{
//             mt: 2,
//             display: "grid",
//             gridTemplateColumns: {
//               xs: "1fr",
//               sm: "repeat(2, 1fr)",
//               md: "repeat(3, 1fr)",
//             },
//             gap: 3,
//           }}
//         >
//           {targets.map((target, index) => {
//             const completed = Number(target?.completed || 0);
//             const targetValue = Number(target?.target || 0);
//             const remarks = target?.remarks || "";
//             const percentage =
//               targetValue > 0 ? Math.round((completed / targetValue) * 100) : 0;

//             return (
//               <Box
//                 key={target.task_id || index}
//                 sx={{
//                   p: 2,
//                   bgcolor: "#fff",
//                   borderRadius: 2,
//                   border: "1px solid #D9D9D9",
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: 1.5,
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
//                 }}
//               >
//                 {/* Header */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
//                     {target.task_name}
//                   </Typography>
//                   <Typography sx={{ fontSize: 14 }}>
//                     Target:{" "}
//                     <span
//                       style={{
//                         fontWeight: 600,
//                         color: "#0f766e",
//                       }}
//                     >
//                       {targetValue}
//                     </span>
//                   </Typography>
//                 </Box>

//                 {/* Description */}
//                 <Typography variant="body2" color="text.secondary">
//                   {target.task_description}
//                 </Typography>

//                 {/* Completed Input - Only editable if initial_completed is 0 */}
//                 <TextField
//                   type="number"
//                   label="Completed"
//                   size="small"
//                   value={completed}
//                   onChange={(e) =>
//                     handleTargetChange(index, "completed", e.target.value)
//                   }
//                   disabled={target.initial_completed !== 0 || !isCurrentWeek}
//                   inputProps={{ min: 0 }}
//                   sx={{
//                     "& .MuiInputBase-input.Mui-disabled": {
//                       WebkitTextFillColor: "#000",
//                       opacity: 0.7,
//                     },
//                   }}
//                 />

//                 {/* Remarks Input - Only editable if initial_completed is 0 */}
//                 <TextField
//                   label="Remarks"
//                   size="small"
//                   multiline
//                   rows={2}
//                   value={remarks}
//                   disabled={target.initial_completed !== 0 || !isCurrentWeek}
//                   onChange={(e) =>
//                     handleTargetChange(index, "remarks", e.target.value)
//                   }
//                   placeholder="Add remarks here..."
//                 />

//                 {/* Progress */}
//                 <Box>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       display: "flex",
//                       justifyContent: "flex-end",
//                       fontWeight: 500,
//                       color: getGradient(percentage).split(",")[1] || "#0f766e",
//                     }}
//                   >
//                     {percentage}%
//                   </Typography>

//                   <LinearProgress
//                     variant="determinate"
//                     value={Math.min(percentage, 100)}
//                     sx={{
//                       height: 8,
//                       borderRadius: 4,
//                       backgroundColor: "#e0e0e0",
//                       "& .MuiLinearProgress-bar": {
//                         background: getGradient(percentage),
//                       },
//                     }}
//                   />
//                 </Box>
//               </Box>
//             );
//           })}
//         </Box>
//       </Box>

//       {/* Save Sprint - Only show for current week */}
//       {isCurrentWeek && !isAllFilled && targets.length > 0 && (
//         <Box mt={6} display="flex" justifyContent="center">
//           <Button
//             onClick={handleSaveSprint}
//             sx={{
//               width: "60%",
//               py: 1.5,
//               borderRadius: "12px",
//               fontWeight: 700,
//               color: "#fff",
//               background: "linear-gradient(90deg, #0f766e, #4338ca)",
//               textTransform: "uppercase",
//               "&:hover": {
//                 background: "linear-gradient(90deg, #4338ca, #0f766e)",
//               },
//             }}
//           >
//             Save Weekly Goals
//           </Button>
//         </Box>
//       )}

//       <Snackbar
//         open={snackBarConfig.open}
//         autoHideDuration={2000}
//         onClose={handleClose}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         sx={{
//           "&.MuiSnackbar-root": {
//             bottom: "56px !important",
//           },
//         }}
//       >
//         <Alert
//           onClose={handleClose}
//           severity={snackBarConfig.severity}
//           variant="filled"
//         >
//           {snackBarConfig.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default WeeklyReport;
import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  Snackbar,
  LinearProgress,
  Alert,
} from "@mui/material";
import { AutoTaskAuthContext } from "../Context/AutoTaskContext";
import axios from "axios";

/* ------------------ Helper Functions ------------------ */
const getCurrentWeek = () => {
  const today = new Date();
  const firstJan = new Date(today.getFullYear(), 0, 1);
  const days = Math.floor((today - firstJan) / (24 * 60 * 60 * 1000));
  return Math.ceil((days + firstJan.getDay() + 1) / 7);
};

const getWeekStartDate = (week, year = new Date().getFullYear()) => {
  const firstDayOfYear = new Date(year, 0, 1);
  return new Date(
    firstDayOfYear.setDate(firstDayOfYear.getDate() + (week - 1) * 7),
  );
};

const getWeekRange = (week, year = new Date().getFullYear()) => {
  const start = getWeekStartDate(week, year);
  const end = new Date(start);
  end.setDate(start.getDate() + 6);

  const format = (d) =>
    d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });

  return `${format(start)} – ${format(end)}`;
};

//------------------- Get gradient ------------------------
const getGradient = (value) => {
  if (value > 80) {
    return "linear-gradient(90deg, #0cb2dbff, #006381ff)";
  }
  if (value >= 60) {
    return "linear-gradient(90deg, #facc15, #f97316)";
  }
  return "linear-gradient(90deg, #ef4444, #f97316)";
};

/* ------------------ WeeklyReport ------------------ */
const WeeklyReport = () => {
  const { userInfo } = useContext(AutoTaskAuthContext) || {};

  const [week, setWeek] = useState(getCurrentWeek());
  const [targets, setTargets] = useState([]);
  const [isAllFilled, isSetAllFilled] = useState(false);

  const [snackBarConfig, setSnackBarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  // ---------- Yes/No weekly ----------
  const [weeklyQuestions, setWeeklyQuestions] = useState([]);
  const [weeklySubmitted, setWeeklySubmitted] = useState(false);
  const [weeklyAnswers, setWeeklyAnswers] = useState({});
  // ------------------------------------

  const currentWeek = getCurrentWeek();
  const isCurrentWeek = week === currentWeek;

  const handleClose = (e, reason) => {
    if (reason === "clickaway") return;
    setSnackBarConfig((prevState) => ({ ...prevState, open: false }));
  };

  useEffect(() => {
    const getWeeklyTasks = async () => {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/weeklyTasks/${userInfo.id}/${week}`;

      try {
        const response = await axios.get(url);

        if (response?.data?.success) {
          const tasks = response?.data?.data || [];

          const hasIncompleteTask = tasks.some((task) => task?.completed == 0);

          hasIncompleteTask ? isSetAllFilled(false) : isSetAllFilled(true);

          const tasksWithInitial = tasks.map((task) => ({
            ...task,
            initial_completed: task.completed,
          }));

          setTargets(tasksWithInitial);
        } else {
          setSnackBarConfig({
            open: true,
            message: response?.data?.message || "Failed to fetch tasks",
            severity: "error",
          });
        }
      } catch (error) {
        setSnackBarConfig({
          open: true,
          message: "Error fetching weekly tasks",
          severity: "error",
        });
      }
    };

    if (userInfo?.id) {
      getWeeklyTasks();
    }
  }, [week, userInfo?.id]);

  // ---------- Fetch weekly Yes/No questions ----------
  useEffect(() => {
    const fetchWeeklyYesNo = async () => {
      if (!userInfo?.id) return;
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/yes-no/today`,
          { params: { user_id: userInfo.id, store_id: userInfo.store_id } },
        );
        if (res.data.success) {
          const { weekly_questions, submitted_week } = res.data.data;
          setWeeklyQuestions(weekly_questions);
          setWeeklySubmitted(submitted_week);

          const preAnswers = {};
          weekly_questions.forEach((q) => {
            if (q.answered) {
              preAnswers[q.id] = q.answer;
            }
          });
          setWeeklyAnswers(preAnswers);
        }
      } catch (err) {
        console.error("Fetch weekly Yes/No failed", err);
      }
    };
    fetchWeeklyYesNo();
  }, [week, userInfo?.id, userInfo?.store_id]);

  const handleTargetChange = (index, field, value) => {
    setTargets((prev) =>
      prev.map((target, i) =>
        i === index ? { ...target, [field]: value } : target,
      ),
    );
  };

  // Month derived from selected week
  const weekStartDate = getWeekStartDate(week);
  const currentMonth = weekStartDate.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  // Calculate completion percentage
  const totalTarget = targets.reduce(
    (sum, t) => sum + Number(t.target || 0),
    0,
  );
  const totalCompleted = targets.reduce(
    (sum, t) => sum + Number(t.completed || 0),
    0,
  );
  const completionPercentage =
    totalTarget > 0 ? Math.round((totalCompleted / totalTarget) * 100) : 0;

  // Handle Save Sprint (with Yes/No submission)
  const handleSaveSprint = async () => {
    // --- Submit weekly Yes/No answers if not submitted ---
    if (!weeklySubmitted && weeklyQuestions.length > 0) {
      const answersPayload = weeklyQuestions
        .map((q) => ({
          question_id: q.id,
          answer: weeklyAnswers[q.id] === 1 ? true : false,
        }))
        .filter((a) => a.answer !== undefined);

      if (answersPayload.length > 0) {
        try {
          const submitRes = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/yes-no/submit`,
            {
              user_id: userInfo.id,
              store_id: userInfo.store_id,
              answers: answersPayload,
            },
          );
          if (!submitRes.data.success) {
            setSnackBarConfig({
              open: true,
              message: submitRes.data.statusMessage,
              severity: "error",
            });
            return;
          }
          setWeeklySubmitted(true);
        } catch (err) {
          setSnackBarConfig({
            open: true,
            message: "Failed to submit Yes/No answers",
            severity: "error",
          });
          return;
        }
      }
    }

    // Existing save goals logic
    const payload = targets.map((target) => ({
      user_task_id: target.task_id,
      week_no: week,
      completed: Number(target.completed || 0),
      remarks: target.remarks || "",
      report_date: new Date().toISOString().split("T")[0],
    }));

    try {
      const url = `${process.env.REACT_APP_API_BASE_URL}/api/ticket/addWeeklyLogs`;
      const response = await axios.post(url, payload);

      if (response?.data?.success) {
        setSnackBarConfig({
          open: true,
          message: "Weekly progress saved successfully",
          severity: "success",
        });
      } else {
        setSnackBarConfig({
          open: true,
          message: response?.data?.statusMessage || "Something went wrong",
          severity: "error",
        });
      }
    } catch (error) {
      setSnackBarConfig({
        open: true,
        message: "Failed to save weekly progress",
        severity: "error",
      });
    }
  };

  return (
    <Box px={4}>
      {/* -------- Week Selector Bar -------- */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
          px: 3,
          py: 2,
          my: 2,
          display: "flex",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Typography fontSize={14} color="text.secondary">
          Month
        </Typography>

        <Box
          sx={{
            px: 2,
            py: 0.7,
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            fontSize: 14,
            color: "#777",
          }}
        >
          {currentMonth}
        </Box>

        <Box sx={{ height: 56, borderRight: "2px solid #dadada75" }} />

        <Typography fontSize={14} color="text.secondary">
          Week
        </Typography>

        <Select
          size="small"
          value={week}
          onChange={(e) => setWeek(e.target.value)}
          sx={{ minWidth: 90, borderRadius: "8px" }}
        >
          {Array.from({ length: 52 }, (_, i) => (
            <MenuItem key={i + 1} value={i + 1}>
              {i + 1}
            </MenuItem>
          ))}
        </Select>

        <Typography sx={{ color: "#a3a3a3ff" }} ml="auto" fontWeight={400}>
          Week {week} ({getWeekRange(week)})
        </Typography>
      </Box>

      {/* Progress Bar */}
      <Box sx={{ width: "100%", mb: 3 }}>
        <LinearProgress
          variant="determinate"
          value={completionPercentage}
          sx={{
            boxShadow: 4,
            height: 20,
            borderRadius: 5,
            backgroundColor: "#e5e7eb",
            "& .MuiLinearProgress-bar": {
              borderRadius: 5,
              background: getGradient(completionPercentage),
            },
          }}
        />

        <Typography
          fontSize={12}
          mt={0.5}
          textAlign="right"
          fontWeight={500}
          color="text.secondary"
        >
          {completionPercentage}% Completed
        </Typography>
      </Box>

      {/* ---------- Weekly Yes/No Questions ---------- */}
      {weeklyQuestions.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Weekly Yes / No Questions
            </Typography>
            {weeklySubmitted && (
              <Typography variant="caption" sx={{ color: "green" }}>
                (Already submitted this week)
              </Typography>
            )}
          </Box>

          {weeklyQuestions.map((q) => {
            const userAnswer = weeklyAnswers[q.id];
            const isYes = userAnswer === 1;
            const isNo = userAnswer === 0;

            return (
              <Box
                key={q.id}
                sx={{
                  mb: 1,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 1,
                  border: "1px solid #e0e0e0",
                  borderRadius: 1,
                }}
              >
                <Typography>{q.question_text}</Typography>

                {weeklySubmitted ? (
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: isYes ? "#16a34a" : "#dc2626",
                      fontSize: 14,
                    }}
                  >
                    {isYes ? "✅ Yes" : "❌ No"}
                  </Typography>
                ) : (
                  <Box>
                    <Button
                      variant={isYes ? "contained" : "outlined"}
                      size="small"
                      onClick={() =>
                        setWeeklyAnswers((prev) => ({ ...prev, [q.id]: 1 }))
                      }
                      sx={{ mr: 1 }}
                    >
                      Yes
                    </Button>
                    <Button
                      variant={isNo ? "contained" : "outlined"}
                      size="small"
                      onClick={() =>
                        setWeeklyAnswers((prev) => ({ ...prev, [q.id]: 0 }))
                      }
                    >
                      No
                    </Button>
                  </Box>
                )}
              </Box>
            );
          })}
        </Box>
      )}

      {/* Weekly Targets Section */}
      <Box>
        <Typography sx={{ mb: 2, fontWeight: "bold", fontSize: 18 }}>
          Weekly Targets
        </Typography>

        {targets.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No targets have been set for this week yet.
          </Typography>
        )}

        <Box
          sx={{
            mt: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
            },
            gap: 3,
          }}
        >
          {targets.map((target, index) => {
            const completed = Number(target?.completed || 0);
            const targetValue = Number(target?.target || 0);
            const remarks = target?.remarks || "";
            const percentage =
              targetValue > 0 ? Math.round((completed / targetValue) * 100) : 0;

            return (
              <Box
                key={target.task_id || index}
                sx={{
                  p: 2,
                  bgcolor: "#fff",
                  borderRadius: 2,
                  border: "1px solid #D9D9D9",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
                    {target.task_name}
                  </Typography>
                  <Typography sx={{ fontSize: 14 }}>
                    Target:{" "}
                    <span
                      style={{
                        fontWeight: 600,
                        color: "#0f766e",
                      }}
                    >
                      {targetValue}
                    </span>
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  {target.task_description}
                </Typography>

                <TextField
                  type="number"
                  label="Completed"
                  size="small"
                  value={completed}
                  onChange={(e) =>
                    handleTargetChange(index, "completed", e.target.value)
                  }
                  disabled={target.initial_completed !== 0 || !isCurrentWeek}
                  inputProps={{ min: 0 }}
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "#000",
                      opacity: 0.7,
                    },
                  }}
                />

                <TextField
                  label="Remarks"
                  size="small"
                  multiline
                  rows={2}
                  value={remarks}
                  disabled={target.initial_completed !== 0 || !isCurrentWeek}
                  onChange={(e) =>
                    handleTargetChange(index, "remarks", e.target.value)
                  }
                  placeholder="Add remarks here..."
                />

                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      fontWeight: 500,
                      color: getGradient(percentage).split(",")[1] || "#0f766e",
                    }}
                  >
                    {percentage}%
                  </Typography>

                  <LinearProgress
                    variant="determinate"
                    value={Math.min(percentage, 100)}
                    sx={{
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: "#e0e0e0",
                      "& .MuiLinearProgress-bar": {
                        background: getGradient(percentage),
                      },
                    }}
                  />
                </Box>
              </Box>
            );
          })}
        </Box>
      </Box>

      {isCurrentWeek && !isAllFilled && targets.length > 0 && (
        <Box mt={6} display="flex" justifyContent="center">
          <Button
            onClick={handleSaveSprint}
            sx={{
              width: "60%",
              py: 1.5,
              borderRadius: "12px",
              fontWeight: 700,
              color: "#fff",
              background: "linear-gradient(90deg, #0f766e, #4338ca)",
              textTransform: "uppercase",
              "&:hover": {
                background: "linear-gradient(90deg, #4338ca, #0f766e)",
              },
            }}
          >
            Save Weekly Goals
          </Button>
        </Box>
      )}

      <Snackbar
        open={snackBarConfig.open}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          "&.MuiSnackbar-root": {
            bottom: "56px !important",
          },
        }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBarConfig.severity}
          variant="filled"
        >
          {snackBarConfig.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default WeeklyReport;
